import { Inject, Pipe, PipeTransform } from '@angular/core';
import { AJSRootScope } from 'ib-web-commons/utils';

@Pipe({ name: 'customCurrency' })
export class CustomCurrencyPipe implements PipeTransform {

    constructor (
        @Inject(AJSRootScope) private $rootScope: any
    ) {}

    transform (value: number, currency: string): string {
        const locale: string = this.$rootScope.appLang + '-' + this.$rootScope.appMarket;
        return new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: currency
        }).format(value);
    }
}